/**
 * AUTOGENERATED, DO NOT EDIT!
 *
 * https://gitlab.com/digital-pharma-tools/open-api-codegen
 *
 */
export enum SalvusAppointmentTypesToShowEnum {
    ALL_AVAILABLE = 'ALL_AVAILABLE',
    APPOINTMENTS = 'APPOINTMENTS',
    RESERVATIONS = 'RESERVATIONS',
    SPECIFIED = 'SPECIFIED',
}